import React from 'react';
import './Inquiry.css';
import { framework } from 'saffroncodejs';
import Config from '../../Core/Config.js';
import { Button, Form, FormGroup, Label, Input, Col, Row, ModalFooter, ModalBody, ModalHeader, Modal } from 'reactstrap';
var PageManager = framework.PageManager;
var $ = require('jquery');
class Inquiry extends React.Component {
  constructor(props) {
    super(props);
    var urlParams = PageManager.decodePageParams(props);
    this.mod=this.encodeSodurId(urlParams[0]);
    this.toggle4 = this.toggle4.bind(this);
    this.state = {
      financialGoal: "",
      number1: "",
      number2: "",
      number3: "",
      birthDateBimeGozar: '',
      number4: '',
      number5: '',
      number6: '',
      birthDateBimeshode: '',
      number7: '',
      number8: '',
      number9: '',
      OptionTypePay: '',
      OptionPrice: '',
      Sick: false,
      MedicalPrice: false,
      Disablement: false,
      Exemption: false,
      OptionDisablement: '',
      OptionDeadPrice: '',
      OptionIncInsPrice: '',
      OptionManzurKardanP: false,
      BimeShode: false,
      OptionmodatBimeName: '',
      setBirthDateYear: '',
      data: [{}],
      modal: false,
      isOpen: false,
    };
    this.setDateDay = this.setDateDay.bind(this);
    this.setDateMonth = this.setDateMonth.bind(this);
    this.setDateYear = this.setDateYear.bind(this);
    this.setBirthDateDay = this.setBirthDateDay.bind(this);
    this.setBirthDateMonth = this.setBirthDateMonth.bind(this);
    this.setBirthDateYear = this.setBirthDateYear.bind(this);
    this.setDeadPrice = this.setDeadPrice.bind(this);
    this.setinsurancePrice = this.setinsurancePrice.bind(this);
    this.setOptionTypePay = this.setOptionTypePay.bind(this);
    this.setOptionPrice = this.setOptionPrice.bind(this);
    this.setSick = this.setSick.bind(this);
    this.setMedicalPrice = this.setMedicalPrice.bind(this);
    this.setDisablement = this.setDisablement.bind(this);
    this.setExemption = this.setExemption.bind(this);
    this.setOptionDisablement = this.setOptionDisablement.bind(this);
    this.setOptionDeadPrice = this.setOptionDeadPrice.bind(this);
    this.setOptionIncInsPrice = this.setOptionIncInsPrice.bind(this);
    this.setOptionManzurKardanP = this.setOptionManzurKardanP.bind(this);
    this.setBimeShode = this.setBimeShode.bind(this);
    this.setOptionmodatBimeName = this.setOptionmodatBimeName.bind(this);
    this.setAndokhte = this.setAndokhte.bind(this);
    this.sendResult=this.sendResult.bind(this);
    this.state.data = [];

    
  }
  encodeSodurId(encodedId) {
    return encodedId;
}
  toggle4() {
      this.setState({
        modal: !this.state.modal
      });
    
  }
  setDateDay(event) {
    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number1: '' });
    }
    else {
      this.setState({ number1: event.target.value });
    }


  }
  setDateMonth(event) {
    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number2: '' });
    }
    else {
      this.setState({ number2: event.target.value });
    }

  }
  setDateYear(event) {

    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number3: '' });
    }
    else {
      this.setState({ number3: event.target.value });
    }
  }
  setBirthDateDay(event) {
    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number4: '' });
    }
    else {
      this.setState({ number4: event.target.value });
    }
  }
  setBirthDateMonth(event) {
    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number5: '' });
    }
    else {
      this.setState({ number5: event.target.value });
    }
    
  }
  setBirthDateYear(event) {
    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number6: '' });
    }
    else {
      this.setState({ number6: event.target.value });
    }
  }
  setDeadPrice(event) {
    this.setState({ number7: event.target.value });
  }
  setinsurancePrice(event) {
    this.setState({ number8: event.target.value });
  }
  setOptionTypePay(event) {
    this.setState({ OptionTypePay: event.target.value });
  }
  setOptionPrice(event) {
    this.setState({ OptionPrice: event.target.value });
  }

  setSick(event) {
    var temp = event.target.value;

    var temp2 = "";

    if (temp && event.target.checked) {
      temp2 = true;
      this.setState({ Sick: temp2 });
    }
    else {
      temp2 = false;
      //alert(temp);
      this.setState({ Sick: temp2 });
    }
  }
  setMedicalPrice(event) {

    var temp = event.target.value;

    var temp2 = "";

    if (temp && event.target.checked) {
      temp2 = true;
      this.setState({ MedicalPrice: temp2 });
    }
    else {
      temp2 = false;
      //alert(temp);
      this.setState({ MedicalPrice: temp2 });
    }
  }
  setDisablement(event) {

    var temp = event.target.value;

    var temp2 = "";

    if (temp && event.target.checked) {
      temp2 = true;
      this.setState({ Disablement: temp2 });
    }
    else {
      temp2 = false;
      // alert(temp);
      this.setState({ Disablement: temp2 });
    }
  }
  setExemption(event) {
    var temp = event.target.value;

    var temp2 = "";

    if (temp && event.target.checked) {
      temp2 = true;
      this.setState({ Exemption: temp2 });
    }
    else {
      temp2 = false;
      // alert(temp);
      this.setState({ Exemption: temp2 });
    }
  }
  setOptionDisablement(event) {
    this.setState({ OptionDisablement: event.target.value });
  }
  setOptionDeadPrice(event) {
    this.setState({ OptionDeadPrice: event.target.value });
  }
  setOptionIncInsPrice(event) {
    this.setState({ OptionIncInsPrice: event.target.value });
  }
  setOptionManzurKardanP(event) {

    var temp = event.target.value;

    var temp2 = "";

    if (temp && event.target.checked) {
      temp2 = true;
      this.setState({ OptionManzurKardanP: temp2 });
    }
    else {
      temp2 = false;
      //alert(temp);
      this.setState({ OptionManzurKardanP: temp2 });
    }


  }
  setBimeShode(event) {

    var temp = event.target.value;

    var temp2 = "";

    if (temp && event.target.checked) {
      temp2 = true;
      this.setState({ BimeShode: temp2 });
    }
    else {
      temp2 = false;
      //alert(temp);
      this.setState({ BimeShode: temp2 });
    }
  }
  setOptionmodatBimeName(event) {
    this.setState({ OptionmodatBimeName: event.target.value });
  }
  setAndokhte(event) {
    this.setState({ number9: event.target.value });
  }



  sendResult() {
    
    //alert('*****'+this.state.number8)
    if (this.state.number6 === '' || this.state.number5 === '' || this.state.number4 === '' || this.state.number7 === '' || this.state.number8 === ''){
      
        this.setState({ modal: !this.state.modal });
      
      if (this.state.number6 === ''){
        
        $('#exampleNumber6').addClass('num_redline');
        $('#exampleNumber6').removeClass('num_line');
      }else{
      $('#exampleNumber6').addClass('num_line');
      $('#exampleNumber6').removeClass('num_redline');
      }
      if(this.state.number5 === ''){
        $('#exampleNumber5').addClass('num_redline');
        $('#exampleNumber5').removeClass('num_line');
  
      }  else{
      $('#exampleNumber5').addClass('num_line');
      $('#exampleNumber5').removeClass('num_redline');
      }
      if(this.state.number4 === ''){
        $('#exampleNumber4').addClass('num_redline');
        $('#exampleNumber4').removeClass('num_line');
      } else{
      $('#exampleNumber4').addClass('num_line');
      $('#exampleNumber4').removeClass('num_redline');
      }
       
       if( this.state.number7 === ''){
        $('#exampleNumber7').addClass('num_redline');
        $('#exampleNumber7').removeClass('num_line');
      }else{
      $('#exampleNumber7').addClass('num_line');
      $('#exampleNumber7').removeClass('num_redline');
      }
      if(this.state.number8 === ''){
        $('#exampleNumber8').addClass('num_redline');
        $('#exampleNumber8').removeClass('num_line');
      }else{
      $('#exampleNumber8').addClass('num_line');
      $('#exampleNumber8').removeClass('num_redline');
      }
    }
    
    else {
     
      PageManager.changePage(Config.p_estelamresult, [this.state.number3, this.state.number2, this.state.number1, this.state.number6, this.state.number5, this.state.number4, this.state.BimeShode, this.state.number7, this.state.number8,
      this.state.OptionTypePay, this.state.OptionPrice, this.state.Sick, this.state.MedicalPrice, this.state.Disablement, this.state.Exemption, this.state.OptionDisablement, this.state.OptionDeadPrice, this.state.OptionIncInsPrice, this.state.OptionManzurKardanP, this.state.number9,
      this.state.OptionmodatBimeName])
    }

  }


  render() {

    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.toggle4} className="alert_phishnahadha">
          <ModalHeader toggle={this.toggle4}></ModalHeader>
          <ModalBody>
            تمام مقادیر اجباری پر شود
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggle4}>بستن </Button>
          </ModalFooter>
        </Modal>

        <Row>
          <Col sm="12" className="alignRight title">
            <h4>استعلام قیمت بیمه نامه عمر</h4>
          </Col>
        </Row>
        <div className="Inquiry-form">

          <div className="container-fluid Inquiry">
            <div className="container">
              <Form >
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                  <Label for="exampleDate" sm={3}>تاریخ تولد بیمه گذار </Label>
                  <Col sm={3} md={2}>
                    <Input type="text" pattern="[0-9]*" maxLength="2" value={this.state.number1} onChange={this.setDateDay} name="number1" id="exampleNumber1" placeholder="روز" />
                  </Col>
                  <Col sm={3} md={2}>
                    <Input type="text" pattern="[0-9]*" maxLength="2" value={this.state.number2} onChange={this.setDateMonth} name="number2" id="exampleNumber2" placeholder="ماه" />
                  </Col>
                  <Col sm={3} md={2}>
                    <Input type="text" pattern="[0-9]*" maxLength="4" value={this.state.number3} onChange={this.setDateYear} name="number3" id="exampleNumber3" placeholder="سال" />
                  </Col>
                </FormGroup>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                  <Label for="exampleDate" sm={3}>تاریخ تولد بیمه شده</Label>
                  <Col sm={3} md={2}>
                    <Input type="text" pattern="[0-9]*" maxLength="2" value={this.state.number4} onChange={this.setBirthDateDay}  name="number4" className="num_line" id="exampleNumber4" placeholder="روز" />
                  </Col>
                  <Col sm={3} md={2}>
                    <Input type="text" pattern="[0-9]*" maxLength="2" value={this.state.number5} onChange={this.setBirthDateMonth}  name="number5" className="num_line" id="exampleNumber5" placeholder="ماه" />
                  </Col>
                  <Col sm={3} md={2}>
                    <Input type="text" pattern="[0-9]*" maxLength="4" value={this.state.number6} onChange={this.setBirthDateYear}   name="number6" className="num_line" id="exampleNumber6" placeholder="سال" />
                  </Col>
                </FormGroup>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                  <Label for="exampleNumber " sm={3} >سرمایه فوت به هر علت</Label>
                  <Col sm={9}>
                    <Input type="text" pattern="[0-9]*" value={this.state.number7} onChange={this.setDeadPrice}  name="number7" id="exampleNumber7" placeholder="عدد وارد نمایید" />
                  </Col>
                </FormGroup>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                  <Label for="exampleNumber" sm={3}>مبلغ حق بیمه</Label>
                  <Col sm={9}>
                    <Input type="text" pattern="[0-9]*" value={this.state.number8} name="number8" onChange={this.setinsurancePrice}  id="exampleNumber8" placeholder="عدد وارد نمایید" />
                  </Col>
                </FormGroup>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                  <Label for="exampleSelect" sm={3}>روش پرداخت حق بیمه</Label>
                  <Col sm={9}>
                    <Input type="select" name="select1" id="paymentSelect" value={this.state.OptionTypePay} onChange={this.setOptionTypePay}>

                      <option value="272">اقساط سالانه</option>
                      <option value="273">اقساط شش ماهه</option>
                      <option value="275">اقساط سه ماهه</option>
                      <option value="277">اقساط ماهانه</option>
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                  <Label for="exampleSelect" sm={3}>سرمایه فوت در اثر حادثه(برابر حادثه فوت به هر علت)</Label>
                  <Col sm={9}>
                    <Input type="select" name="select" id="exampleSelect" onChange={this.setOptionPrice}>
                     
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup check className="mb-2 mr-sm-2 mb-sm-0 row" >
                  <Col sm={12} className="text-right">
                    <Label check>
                      <Row>
                        <Col sm={3} className="text-right">
                          پوشش امراض خاص
                    </Col>
                        <Col sm={9} className="text-right">
                          <Input type="checkbox" checked={this.state.active} value={this.state.Sick} onChange={this.setSick} /><span class="checkmark"></span>
                        </Col>
                      </Row>
                    </Label>
                  </Col>
                  <Col sm={12} className="text-right">
                    <Label check>
                      <Row>
                        <Col sm={3} className="text-right">
                          پوشش هزینه پزشکی ناشی از حادثه
                    </Col>
                        <Col sm={3} className="text-right">
                          <Input type="checkbox" checked={this.state.active} value={this.state.MedicalPrice} onChange={this.setMedicalPrice} /><span class="checkmark"></span>
                        </Col>
                      </Row>
                    </Label>
                  </Col>
                  <Col sm={12} className="text-right">
                    <Label check>
                      <Row>
                        <Col sm={3} className="text-right">
                          پوشش از کارافتادگی دائم و کامل ناشی از حادثه
                  </Col>
                        <Col sm={3} className="text-right">
                          <Input type="checkbox" checked={this.state.active} value={this.state.Disablement} onChange={this.setDisablement} /><span class="checkmark"></span>
                        </Col>
                      </Row>
                    </Label>
                  </Col>
                  <Col sm={12} className="text-right">
                    <Label check>
                      <Row>
                        <Col sm={3} className="text-right">
                          پوشش معافیت از پرداخت حق بیمه
                  </Col>
                        <Col sm={9} className="text-right">
                          <Input type="checkbox" checked={this.state.active} value={this.state.Exemption} onChange={this.setExemption} /><span class="checkmark"></span>
                        </Col>
                      </Row>
                    </Label>
                  </Col>
                </FormGroup>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                  <Label for="exampleSelect" sm={3}>پوشش مستمری از کارافتادگی (برابر حق بیمه پرداختی هر سال)</Label>
                  <Col sm={9}>
                    <Input type="select" name="select" id="exampleSelect2" onChange={this.setOptionDisablement}>
                    
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                  <Label for="exampleSelect" sm={3}>درصد افزایش سرمایه فوت</Label>
                  <Col sm={9}>
                    <Input type="select" name="select" id="exampleSelect3" onChange={this.setOptionDeadPrice}>
                     
                      <option value={5 / 100}>5</option>
                      <option value={10 / 100}>10</option>
                      <option value={15 / 100}>15</option>
                      <option value={20 / 100}>20</option>
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                  <Label for="exampleSelect" sm={3}>درصد افزایش حق بیمه</Label>
                  <Col sm={9}>
                    <Input type="select" name="select" id="exampleSelect4" onChange={this.setOptionIncInsPrice}>
                     
                      <option value={0 / 100}>0</option>
                      <option value={5 / 100}>5</option>
                      <option value={10 / 100}>10</option>
                      <option value={15 / 100}>15</option>
                      <option value={20 / 100}>20</option>
                      <option value={25 / 100}>25</option>
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup check className="mb-2 mr-sm-2 mb-sm-0 row">

                  <Col sm={12} className="text-right">
                    <Label check>
                      <Row>
                        <Col sm={3} className="text-right">
                          منظور کردن پوشش ها در حق بیمه اولیه
                    </Col>
                        <Col sm={9} className="text-right">
                          <Input type="checkbox" checked={this.state.active} value={this.state.OptionManzurKardanP} onChange={this.setOptionManzurKardanP} /><span class="checkmark"></span>
                        </Col>
                      </Row>
                    </Label>
                  </Col>
                  <Col sm={12} className="text-right">
                    <Label check>
                      <Row>
                        <Col sm={3} className="text-right">
                          بیمه شده و بیمه گذار یکی می باشند
                    </Col>
                        <Col sm={9} className="text-right">
                          <Input type="checkbox" checked={this.state.active} value={this.state.BimeShode} onChange={this.setBimeShode} /><span class="checkmark"></span>
                        </Col>
                      </Row>
                    </Label>
                  </Col>
                </FormGroup>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                  <Label for="exampleSelect" sm={3}>مدت بیمه نامه(سال)</Label>
                  <Col sm={9}>
                    <Input type="select" name="select" onChange={this.setOptionmodatBimeName} id="exampleSelect5">
                      
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                    </Input>

                  </Col>
                </FormGroup>

                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>

                  <Label for="exampleNumber" sm={3}>اندوخته</Label>
                  <Col sm={9}>
                    <Input type="text" pattern="[0-9]*" value={this.state.number9} name="number9" id="exampleNumber9" placeholder="عدد وارد نمایید" onChange={this.setAndokhte} />

                  </Col>
                </FormGroup>
                <br />
                <div className="buttons">


                  {/* <Button onClick={()=>{this.pagechange(this.state.number3+'/'+this.state.number2+'/'+this.state.number1,this.state.number6+'/'+this.state.number5+'/'+this.state.number4,this.state.number7,this.state.number8,
                this.state.number9,this.state.OptionTypePay,this.state.OptionPrice,this.state.Sick,this.state.MedicalPrice,this.state.Disablement,this.state.Exemption,this.state.OptionDisablement,this.state.OptionDeadPrice,this.state.OptionIncInsPrice,this.state.OptionManzurKardanP,this.state.BimeShode,
                this.state.OptionmodatBimeName)}}> */}

                  <Button onClick={this.sendResult}>
                    خروجی</Button>

                </div>
                <br />
                <br />
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { Inquiry };


// WEBPACK FOOTER //
// ./src/components/Inquiry/Inquiry.js